import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { PipelineIncidentData } from './types';
import PipelineRunInfo from './PipelineRunInfo';

const Wrapper = styled(FlexColumn)`
  background-color: ${({ theme }) => theme.palette.common.gray15};
  padding: 16px 24px;
  gap: 24px;
  border-radius: 8px;
`;

type Props = {
  data: PipelineIncidentData;
};

const PipelineExecutionInfo = ({ data }: Props) => (
  <Wrapper>
    <PipelineRunInfo eventId={data.rootEventId} connectorData={data} />
  </Wrapper>
);

export default PipelineExecutionInfo;
